import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { handleShowSidebar } from "store/sidebarReducer/sidebarSlice";
import DropdownNotification from "./parts/DropdownNotification";

const DashboardHeader = () => {
	const dispatch = useDispatch();
	const ShowSidebar = () => {
		dispatch(handleShowSidebar());
	};
	const titlePageCurrent = useSelector(
		state => state.topbar.titlePageCurrent
	);
	return (
		<div className='admin-header-top sticky top-0 z-10 h-60px px-34px flex justify-between items-center shadow-[0px_4px_4px_rgba(0,0,0,0.05)] bg-white'>
			<div className='header-left flex items-center gap-4'>
				<div
					className='header-hambuger xl:hidden w-60px h-60px bg-primary text-white text-center flex items-center justify-center text-3xl'
					onClick={ShowSidebar}>
					<em className='fa-solid fa-bars'></em>
				</div>
				<div className='header-text text-2xl font-bold'>
					{titlePageCurrent}
				</div>
			</div>
			<div className='header-right flex items-center'>
				<div className='header-notification relative'>

					<DropdownNotification></DropdownNotification>
				</div>
				<div className='header-account flex items-center ml-5 before:content-[] before:w-1px before:h-16px before:bg-[#DDDDDD] before:mr-18px'>
					<em className='fa-regular fa-user'></em>
					<div className='header-account-dropdown flex items-center ml-4 cursor-pointer'>
						<span className='text-sm inline-block mr-1'>
							Băng Tâm
						</span>
						<em className='fa-regular fa-angle-down'></em>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DashboardHeader;
